import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ColDef, GridApi, GridOptions , GridReadyEvent } from "ag-grid-community";
import { ToastrService } from "ngx-toastr";
import { Plan } from "src/app/generated-models/Plan";
import { ApiService } from "src/app/services";
import { ColParams } from "src/app/shared/grid/ag-grid";
import { LinkCellComponent } from "src/app/shared/grid/link-cell.component";
import { LoadingScreenService } from "src/app/shared/loading-screen.service";
import * as CDs from "src/app/utility/commonColDef";
import { extendDefaultOptions } from "src/app/utility/gridHelper";
import { PreprocessDateTime } from "src/app/utility/view-field-mapping";

@Component({
  standalone: false,
  templateUrl: "./plan-history-modal.component.html",
  styleUrls: ["../../../../styles.scss", "../../plan.scss"],
})
export class PlanHistoryModalComponent implements OnInit {
  @Input() serviceTreeId: string;
  @Input() name: string;
  gridOptions: GridOptions;
  gridApi: GridApi;
  rowData: Plan[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private notificationService: ToastrService,
    private apiService: ApiService,
    private loadingService: LoadingScreenService
  ) {
    this.loadingService.setLoading(true);
  }

  ngOnInit() {
    const planHistoryCellComponentParams = {
      target: "_blank",
      url: (params: ColParams<Plan, string>) => {
        if (params.data.Name) {
          return `/quota/plans/services/${params.data.ServiceTreeId}/${params.data.Name}/versions/${params.data.Version}`;
        }
        return `/quota/plans/services/${params.data.ServiceTreeId}/versions/${params.data.Version}`;
      },
    };

    const columnDefinition: ColDef[] = [
      {
        ...CDs.Version,
        width: 80,
        cellRenderer: LinkCellComponent,
        cellRendererParams: planHistoryCellComponentParams,
      },
      {
        ...CDs.CreatedTime,
        cellRenderer: (params) => PreprocessDateTime(params.value),
        width: 120,
      },
      {
        ...CDs.CreatedBy,
        width: 80,
      },
      CDs.Comment,
    ];

    this.gridOptions = extendDefaultOptions({
      columnDefs: columnDefinition,
      suppressPaginationPanel: true,
      sideBar: null,
      animateRows: true,
    });

    this.getPlanHistory(this.serviceTreeId, this.name);
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

  getPlanHistory(serviceTreeId: string, name: string) {
    this.apiService.getPlansHistory(serviceTreeId, name).subscribe(
      (data) => {
        this.rowData = data;
        if (this.gridApi) {
          this.gridApi.setGridOption("rowData", this.rowData);
        }
        this.loadingService.setLoading(false);
        setTimeout(() => {
          //this.gridApi.autoSizeAllColumns();
          this.gridApi.sizeColumnsToFit();
        }, 100);
      },
      (e: any) => {
        this.rowData = [];
        this.loadingService.setLoading(false);
        this.notificationService.error(e);
      }
    );
  }
}
